var _style, _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNoProductsFound(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 841.89 595.28",
    style: {
      enableBackground: "new 0 0 841.89 595.28"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:none;stroke:#9D9FA0;stroke-width:3;stroke-miterlimit:10;}\r\n\t.st1{fill:#9D9FA0;}\r\n\t.st2{fill:none;stroke:#9D9FA0;stroke-width:1.5;stroke-miterlimit:10;}\r\n\t.st3{fill:#FFFFFF;}\r\n\t.st4{fill:none;stroke:#9D9FA0;stroke-miterlimit:10;}\r\n\t.st5{fill:none;stroke:#9D9FA0;stroke-width:0.75;stroke-linecap:round;stroke-miterlimit:10;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M444.18,262.34v7.49c0,2.08-0.33,4.08-0.94,5.96h-42.71c-0.61-1.88-0.94-3.88-0.94-5.96v-7.49 c0-10.62,8.61-19.23,19.23-19.23h6.13C435.57,243.11,444.18,251.72,444.18,262.34z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "467.33,366 377.12,366 383.55,275.79 458.82,275.79  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 402.83,
    cy: 301.15,
    r: 3.4
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 441.61,
    cy: 301.15,
    r: 3.4
  }))), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M421.79,334.76L421.79,334.76c-4.37,0-7.91-3.54-7.91-7.91v-5.87c0-4.37,3.54-7.91,7.91-7.91h0 c4.37,0,7.91,3.54,7.91,7.91v5.87C429.71,331.22,426.17,334.76,421.79,334.76z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 407.84,
    y: 322.17,
    className: "st3",
    width: 30.72,
    height: 14.64
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M370.61,245.21l-3.16-2.28c0.67-1.43,1.77-2.69,3.29-3.76c1.52-1.07,3.26-1.78,5.2-2.13l0.62,3.67 c-1.21,0.22-2.34,0.73-3.4,1.55C372.1,243.07,371.25,244.06,370.61,245.21z M376.74,256.48l-0.33-1.85 c-0.23-1.27-0.17-2.44,0.18-3.51c0.35-1.07,0.99-2.03,1.93-2.88c0.93-0.83,1.58-1.67,1.96-2.53c0.38-0.86,0.49-1.73,0.33-2.62 c-0.17-0.96-0.63-1.66-1.37-2.07c-0.74-0.42-1.7-0.52-2.88-0.31l-0.62-3.67c2.51-0.45,4.55-0.23,6.14,0.65 c1.59,0.89,2.56,2.37,2.94,4.44c0.26,1.43,0.14,2.79-0.37,4.09s-1.38,2.53-2.65,3.7c-0.73,0.69-1.24,1.39-1.53,2.1 c-0.3,0.71-0.38,1.44-0.24,2.2l0.29,1.58L376.74,256.48z M380.36,265.3c-0.78,0.14-1.51-0.02-2.17-0.47 c-0.66-0.46-1.06-1.08-1.2-1.86c-0.14-0.8,0.01-1.52,0.47-2.18c0.46-0.65,1.08-1.05,1.86-1.19c0.8-0.14,1.52,0.01,2.17,0.46 c0.65,0.45,1.05,1.08,1.19,1.88c0.14,0.78-0.01,1.5-0.47,2.16C381.78,264.75,381.16,265.16,380.36,265.3z"
  })))), /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 364.26,
    cy: 309.49,
    r: 3.57
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 476.33,
    cy: 323.91,
    r: 2.66
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 476.99,
    y1: 292.64,
    x2: 481.2,
    y2: 296.98
  }), /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 481.2,
    y1: 292.64,
    x2: 476.98,
    y2: 296.97
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 366.88,
    y1: 336.34,
    x2: 366.75,
    y2: 342.38
  }), /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 369.84,
    y1: 339.34,
    x2: 363.79,
    y2: 339.38
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoProductsFound);
export default __webpack_public_path__ + "static/media/no-products-found.ca5842bcd77fe50e6afca8f4b8ee068e.svg";
export { ForwardRef as ReactComponent };